import { SitecoreFieldValidator } from '_utils/validationChecks/definitions';

export const PageBannerFieldValidators: SitecoreFieldValidator[] = [
  {
    field: 'rendering.fields.data.pageFields.Heading',
    errorMessage: 'A page title must be set or this component will not render',
    required: true
  }
];
